import PageHeader from 'src/components/page-header/page-header';

export default function SiloControlHeader() {
  return <PageHeader title="Controle de Silos" />;
}
